import { styled } from 'baseui'

export const SettingsSection = styled('section', {
  maxWidth: '26rem',
  marginTop: '1.5rem',
})

export const SettingsRow = styled('div', {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  columnGap: '1.5rem',
})

export const SectionTitle = styled('h3', ({ $theme }) => ({
  marginTop: 0,
  marginBottom: '0.5rem',
  fontSize: '1rem',
  fontWeight: 400,
  color: $theme.colors.primary,
}))

export const SubmitButtonOverrides = {
  BaseButton: {
    style: ({ $theme }: any) => ({
      backgroundColor: $theme.colors.warning,
      ':hover': {
        backgroundColor: $theme.colors.warning400,
      },
    }),
  },
}

export const ModalText = styled('p', ({ $theme }) => ({
  textAlign: 'center',
  color: $theme.colors.textMuted,
}))

export const ModalActions = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  marginTop: '1rem',
})
